import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    volume: {
        hourly: {
            loading: true,
            data: {},
            error: null,
        },
        daily: {
            loading: true,
            data: {},
            error: null,
        }
    },
    peak: {
        hourly: {
            loading: true,
            data: {},
            error: null,
        },
        daily: {
            loading: true,
            data: {},
            error: null,
        }
    }
}

export const domainCallReportSlice = createSlice({
    name: 'domainCallReport',
    initialState,
    reducers: {
        setDomainCallReport: (state, action) => {
            const { reportType, timeframe, data } = action.payload;
            state[reportType][timeframe].loading = false;
            state[reportType][timeframe].data = data;
            state[reportType][timeframe].error = null;
        },
        resetDomainCallReport: () => initialState,

    },

});

export const {
    setDomainCallReport,
    resetDomainCallReport
} = domainCallReportSlice.actions;

export const selectDomainVolumeHourly = (state) => state.domainCallReport.volume.hourly;
export const selectDomainVolumeDaily = (state) => state.domainCallReport.volume.daily;
export const selectDomainPeakHourly = (state) => state.domainCallReport.peak.hourly;
export const selectDomainPeakDaily = (state) => state.domainCallReport.peak.daily;

export default domainCallReportSlice.reducer;